import { useContext } from 'react';

import { Tooltip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation, Link } from 'react-router-dom';
import { MIN_WIDTH_TO_COLLAPSE_MENU } from 'utils/shared/const';

import { SpecialistContext } from 'context';

import IconBadge from 'components/IconBadge';

import * as S from './style';

import { MenuItemProps } from './types';

const MenuItem: React.FC<MenuItemProps> = ({
  itemKey,
  title,
  baseUrls,
  redirectUrl,
  Icon,
  IconSelected,
  onClick,
  hasNotification,
  totalNotification,
  allowedRoles,
  allowedGeoCodes,
}) => {
  const location = useLocation();
  const intl = useIntl();
  const isSelected = baseUrls.some(url => location.pathname.includes(url));
  const { specialistInfo } = useContext(SpecialistContext);

  const hasPermission = () => {
    return allowedRoles.some(role => specialistInfo?.groups?.includes(role));
  };

  const hasGeoPermission = () => {
    if (!allowedGeoCodes || allowedGeoCodes.length === 0) {
      return true; // No geo restrictions, allow access
    }
    return allowedGeoCodes.some(geo => specialistInfo?.geoCode === geo);
  };

  if (!hasPermission() || !hasGeoPermission()) {
    return <></>;
  }

  const menuIsCollapsed = window.innerWidth <= MIN_WIDTH_TO_COLLAPSE_MENU;

  return (
    <Link to={redirectUrl} onClick={() => onClick?.(itemKey)}>
      <S.Container isSelected={isSelected} data-testid="menu-item">
        <S.Row>
          <Tooltip
            title={intl.formatMessage({ id: title })}
            placement="right"
            arrow
            disableHoverListener={!menuIsCollapsed}
          >
            {isSelected ? (
              <span>
                <IconSelected />
              </span>
            ) : (
              <span>
                <IconBadge
                  show={hasNotification}
                  value={totalNotification}
                  max={99}
                >
                  <Icon />
                </IconBadge>
              </span>
            )}
          </Tooltip>

          <S.Title isSelected={isSelected}>
            <FormattedMessage id={title} />
          </S.Title>
        </S.Row>
      </S.Container>
    </Link>
  );
};

export default MenuItem;
